export const icons = [
  'material-symbols:code-off-rounded',
  'material-symbols:code-rounded',
  'material-symbols:library-add-check-outline-rounded',
  'material-symbols:content-copy-outline-rounded',
  'material-symbols:warning-outline-rounded',
  'material-symbols:check-small-rounded',
  'material-symbols:credit-card-outline',
  'material-symbols:local-shipping-outline-rounded',
  'material-symbols:package-2-outline',
  'material-symbols:reviews-outline-rounded',
  'material-symbols:favorite-outline-rounded',
  'material-symbols:store-outline-rounded',
  'material-symbols:sell-outline',
  'material-symbols:lock-outline',
  'material-symbols:redeem-rounded',
  'material-symbols:payments-outline-rounded',
  'material-symbols:support',
  'material-symbols:chat-outline-rounded',
  'material-symbols:list-rounded',
  'material-symbols:support-agent-rounded',
  'material-symbols:attach-money-rounded',
  'material-symbols:storefront-outline-rounded',
  'material-symbols:help-outline-rounded',
  'material-symbols:box-add-outline-rounded',
  'material-symbols:rocket-launch-outline-rounded',
  'material-symbols:live-help-outline-rounded',
  'material-symbols:orders-outline-rounded',
  'material-symbols:looks-one-outline-rounded',
  'material-symbols-light:ads-click-rounded',
  'material-symbols-light:request-quote-outline-rounded',
  'material-symbols-light:shopping-cart-checkout-rounded',
  'material-symbols-light:local-shipping-outline-rounded',
  'material-symbols-light:shopping-bag-outline',
  'material-symbols-light:verified-outline-rounded',
  'material-symbols-light:credit-score-outline-rounded',
  'material-symbols-light:verified-user-outline-rounded',
  'material-symbols-light:keyboard-return-rounded',
  'material-symbols:cake-rounded',
  'material-symbols:person-add-rounded',
  'material-symbols:mode-comment-rounded',
  'material-symbols-light:favorite-rounded',
  'material-symbols:imagesmode-rounded',
  'material-symbols:group-rounded',
  'material-symbols:sell',
  'material-symbols:folder-zip-outline-rounded',
  'material-symbols:picture-as-pdf-outline-rounded',
  'material-symbols:arrow-drop-down',
  'material-symbols:delete',
  'material-symbols:view-quilt-outline',
  'material-symbols:play-circle-outline-rounded',
  'material-symbols:data-exploration-outline-rounded',
  'material-symbols-light:lightbulb-outline-rounded',
  'material-symbols-light:light-off-outline-rounded',
  'material-symbols:left-panel-open-outline',
  'material-symbols:left-panel-close-outline',
  'material-symbols:link-rounded',
  'material-symbols:add-photo-alternate-outline-rounded',
  'material-symbols:close-small-rounded',
  'material-symbols:location-on-rounded',
  'material-symbols:zoom-in-rounded',
  'material-symbols:zoom-out-rounded',
  'material-symbols:chevron-left-rounded',
  'material-symbols:chevron-right-rounded',
  'material-symbols-light:visibility-outline-rounded',
  'material-symbols-light:visibility-off-outline-rounded',
  'material-symbols:folder-outline',
  'material-symbols:open-in-new-rounded',
  'material-symbols:arrow-back-ios-rounded',
  'material-symbols:arrow-forward-ios-rounded',
  'material-symbols:info-outline-rounded',
  'material-symbols:close-rounded',
  'material-symbols:square-rounded',
  'material-symbols:search-rounded',
  'material-symbols:calendar-today-outline',
  'material-symbols:download-rounded',
  'material-symbols:mail-outline-rounded',
  'material-symbols:call-outline',
  'material-symbols:circle',
  'material-symbols:keyboard-arrow-down-rounded',
  'material-symbols:arrow-back-rounded',
  'material-symbols:arrow-forward-rounded',
  'material-symbols:star-rounded',
  'material-symbols:swap-vert-rounded',
  'material-symbols:expand-more-rounded',
  'material-symbols:add-rounded',
  'material-symbols:delete-outline-rounded',
  'material-symbols:check-circle-rounded',
  'material-symbols:drag-indicator',
  'material-symbols:crop-square',
  'material-symbols:check-box',
  'material-symbols:remove-rounded',
  'material-symbols:stars-rounded',
  'material-symbols:edit-outline-rounded',
  'material-symbols-light:chat-outline-rounded',
  'material-symbols:inventory-2-outline-rounded',
  'material-symbols:verified-user-outline-rounded',
  'material-symbols:handyman-outline',
  'material-symbols:u-turn-left-rounded',
  'material-symbols:border-color-outline-rounded',
  'material-symbols-light:more-vert',
  'material-symbols:thumb-up-outline-rounded',
  'material-symbols:thumb-down-outline-rounded',
  'material-symbols:qr-code-scanner-rounded',
  'material-symbols:restart-alt-rounded',
  'material-symbols:arrow-drop-up-rounded',
  'material-symbols:arrow-drop-down-rounded',
  'material-symbols:filter-alt-outline',
  'material-symbols:add-shopping-cart-rounded',
  'material-symbols:compare-rounded',
  'material-symbols:share-outline',
  'material-symbols:more-horiz',
  'material-symbols:reset-settings-rounded',
  'material-symbols:light-mode-outline-rounded',
  'material-symbols-light:dark-mode-outline-rounded',
  'material-symbols:monitor-outline-rounded',
  'material-symbols-light:keyboard-arrow-down',
  'material-symbols-light:arrow-downward-alt',
  'material-symbols-light:shield-question',
  'material-symbols-light:database',
  'material-symbols-light:check-circle',
  'material-symbols-light:warning',
  'material-symbols:info',
  'material-symbols-light:bug-report',
  'material-symbols:error-rounded',
  'material-symbols:warning-rounded',
  'material-symbols:info-rounded',
  'material-symbols-light:cancel-outline',
  'material-symbols:menu',
  'material-symbols:account-circle',
  'material-symbols:adb',
  'material-symbols:search',
  'material-symbols:mail',
  'material-symbols:notifications',
  'material-symbols:more-vert',
  'material-symbols:add',
  'material-symbols:assignment-outline',
  'material-symbols-light:folder',
  'material-symbols-light:pageview',
  'material-symbols-light:notifications',
  'material-symbols:mail-rounded',
  'material-symbols-light:mail-outline',
  'material-symbols-light:mail-rounded',
  'material-symbols-light:account-circle-outline',
  'material-symbols-light:remove',
  'material-symbols-light:add',
  'material-symbols-light:autorenew',
  'material-symbols-light:favorite',
  'material-symbols-light:location-on',
  'material-symbols:navigate-next',
  'material-symbols:home',
  'material-symbols:whatshot',
  'material-symbols:grain',
  'material-symbols:keyboard-arrow-down',
  'material-symbols:add-circle-outline-rounded',
  'material-symbols:send',
  'material-symbols:alarm-outline-rounded',
  'material-symbols:add-shopping-cart',
  'material-symbols:fingerprint',
  'material-symbols:cloud-upload',
  'material-symbols:save',
  'material-symbols-light:share',
  'material-symbols-light:expand-all',
  'material-symbols-light:skip-previous',
  'material-symbols-light:play-circle',
  'material-symbols-light:skip-next',
  'material-symbols:favorite-outline',
  'material-symbols:favorite',
  'material-symbols:bookmark-outline',
  'material-symbols:bookmark',
  'material-symbols:done',
  'material-symbols:delete-forever',
  'material-symbols:face',
  'material-symbols:person',
  'material-symbols:close',
  'material-symbols-light:format-align-left',
  'material-symbols-light:format-align-justify',
  'material-symbols-light:format-align-right',
  'material-symbols-light:format-bold',
  'material-symbols-light:format-italic',
  'material-symbols-light:inbox',
  'material-symbols-light:mail',
  'material-symbols-light:menu',
  'material-symbols-light:chevron-left',
  'material-symbols-light:chevron-right',
  'material-symbols:edit',
  'material-symbols:navigation',
  'material-symbols:keyboard-arrow-up',
  'material-symbols:home-rounded',
  'material-symbols-light:info',
  'material-symbols-light:drafts',
  'material-symbols-light:send',
  'material-symbols-light:keyboard-arrow-up',
  'material-symbols-light:star-outline',
  'material-symbols-light:image',
  'material-symbols-light:work',
  'material-symbols-light:beach-access',
  'material-symbols-light:delete',
  'material-symbols-light:send-rounded',
  'material-symbols-light:comment',
  'material-symbols-light:wifi-rounded',
  'material-symbols-light:wifi-off-rounded',
  'material-symbols-light:bluetooth-rounded',
  'material-symbols-light:bluetooth-disabled',
  'material-symbols-light:account-box',
  'material-symbols:content-cut',
  'material-symbols:content-copy-outline',
  'material-symbols:content-paste',
  'material-symbols:cloud',
  'material-symbols:check',
  'material-symbols:person-add',
  'material-symbols:settings',
  'material-symbols:logout',
  'material-symbols-light:arrow-left-alt',
  'material-symbols-light:arrow-right-alt',
  'material-symbols-light:save',
  'material-symbols-light:star',
  'material-symbols-light:sentiment-sad-outline',
  'material-symbols-light:sentiment-worried-outline',
  'material-symbols-light:sentiment-content-outline',
  'material-symbols-light:sentiment-calm-outline',
  'material-symbols-light:sentiment-excited-outline',
  'material-symbols:play-circle-rounded',
  'material-symbols:pause-circle-rounded',
  'material-symbols:volume-down',
  'material-symbols:volume-up',
  'material-symbols:volume-up-outline-rounded',
  'material-symbols:volume-off-outline-rounded',
  'material-symbols:file-copy',
  'material-symbols:print',
  'material-symbols:share',
  'material-symbols:keyboard-arrow-left',
  'material-symbols:keyboard-arrow-right',
  'material-symbols:filter-list',
  'material-symbols-light:phone-in-talk-outline-sharp',
  'material-symbols-light:import-contacts-outline',
  'material-symbols-light:account-circle',
  'material-symbols-light:smartphone',
  'material-symbols-light:phone-in-talk',
  'material-symbols:visibility-off',
  'material-symbols:visibility',
  'material-symbols:format-align-left',
  'material-symbols:format-align-center',
  'material-symbols:format-align-right',
  'material-symbols:format-align-justify',
  'material-symbols:format-bold',
  'material-symbols:format-italic',
  'material-symbols:format-underlined',
  'material-symbols:format-color-fill',
  'material-symbols:view-list-sharp',
  'material-symbols:view-module-sharp',
  'material-symbols:view-quilt-sharp',
  'material-symbols:laptop-windows-outline',
  'material-symbols:tv-outline',
  'material-symbols:phone-android',
  'material-symbols-light:keyboard-arrow-right',
  'material-symbols-light:shopping-cart-outline-rounded',
  'material-symbols:arrow-right-alt-rounded',
  'material-symbols:menu-rounded',
  'material-symbols-light:download-rounded',
  'material-symbols-light:notifications-outline-rounded',
  'material-symbols:diamond-rounded',
  'material-symbols:accessible-forward-rounded',
  'material-symbols:dark-mode-outline-rounded',
  'material-symbols:settings-account-box-outline-rounded',
  'material-symbols:logout-rounded',
  'material-symbols:login-rounded',
  'material-symbols:settings-outline',
  'material-symbols:print-outline-rounded',
  'material-symbols:notifications-outline-rounded',
  'material-symbols:person-add-outline-rounded',
  'material-symbols:check-rounded',
  'material-symbols:waving-hand-outline-rounded',
  'material-symbols:check-box-outline-rounded',
  'material-symbols:error-outline-rounded',
  'material-symbols:check-circle-outline-rounded',
  'material-symbols:cancel-rounded',
  'material-symbols:sort-rounded',
  'material-symbols:keyboard-double-arrow-left-rounded',
  'material-symbols:keyboard-double-arrow-right-rounded',
  'material-symbols:shopping-cart-outline',
  'material-symbols:pending-actions-rounded',
  'material-symbols:phone-in-talk-outline-rounded',
  'material-symbols:query-stats-rounded',
  'material-symbols:manage-accounts-outline',
  'material-symbols:widgets-outline-rounded',
  'material-symbols:security-rounded',
  'material-symbols:dashboard-customize-outline-rounded',
  'material-symbols:flight-land-rounded',
  'material-symbols:manage-accounts-outline-rounded',
  'material-symbols:quiz-outline-rounded',
  'material-symbols:layers-outline-rounded',
  'material-symbols:favorite-rounded',
  'material-symbols:favorite-outline-rounded',
  'twemoji:flag-united-kingdom',
  'twemoji:flag-france',
  'twemoji:flag-bangladesh',
  'twemoji:flag-china',
  'twemoji:flag-india',
  'twemoji:flag-saudi-arabia',
  'ic:round-check',
  'ic:round-do-not-disturb-alt',
  'ic:outline-draw',
  'ic:round-home',
  'ic:sharp-tiktok',
  'ri:twitter-x-fill',
  'ri:instagram-line',
  'mdi:apple',
  'mdi-light:home',
  'mdi:home',
  'mdi:edit-outline',
  'mdi:whatsapp',
  'mdi:share-variant-outline',
  'fa-brands:viber',
  'fa6-brands:amazon',
  'eva:facebook-fill',
  'entypo-social:pinterest',

  'flag:ad-4x3',
  'flag:ae-4x3',
  'flag:af-4x3',
  'flag:ag-4x3',
  'flag:ai-4x3',
  'flag:al-4x3',
  'flag:am-4x3',
  'flag:ao-4x3',
  'flag:aq-4x3',
  'flag:ar-4x3',
  'flag:as-4x3',
  'flag:at-4x3',
  'flag:au-4x3',
  'flag:aw-4x3',
  'flag:ax-4x3',
  'flag:az-4x3',
  'flag:ba-4x3',
  'flag:bb-4x3',
  'flag:bd-4x3',
  'flag:be-4x3',
  'flag:bf-4x3',
  'flag:bg-4x3',
  'flag:bh-4x3',
  'flag:bi-4x3',
  'flag:bj-4x3',
  'flag:bl-4x3',
  'flag:bm-4x3',
  'flag:bn-4x3',
  'flag:bo-4x3',
  'flag:br-4x3',
  'flag:bs-4x3',
  'flag:bt-4x3',
  'flag:bv-4x3',
  'flag:bw-4x3',
  'flag:by-4x3',
  'flag:bz-4x3',
  'flag:ca-4x3',
  'flag:cc-4x3',
  'flag:cd-4x3',
  'flag:cf-4x3',
  'flag:cg-4x3',
  'flag:ch-4x3',
  'flag:ci-4x3',
  'flag:ck-4x3',
  'flag:cl-4x3',
  'flag:cm-4x3',
  'flag:cn-4x3',
  'flag:co-4x3',
  'flag:cr-4x3',
  'flag:cu-4x3',
  'flag:cv-4x3',
  'flag:cw-4x3',
  'flag:cx-4x3',
  'flag:cy-4x3',
  'flag:cz-4x3',
  'flag:de-4x3',
  'flag:dj-4x3',
  'flag:dk-4x3',
  'flag:dm-4x3',
  'flag:do-4x3',
  'flag:dz-4x3',
  'flag:ec-4x3',
  'flag:ee-4x3',
  'flag:eg-4x3',
  'flag:eh-4x3',
  'flag:er-4x3',
  'flag:es-4x3',
  'flag:et-4x3',
  'flag:fi-4x3',
  'flag:fj-4x3',
  'flag:fk-4x3',
  'flag:fm-4x3',
  'flag:fo-4x3',
  'flag:fr-4x3',
  'flag:ga-4x3',
  'flag:gb-4x3',
  'flag:gd-4x3',
  'flag:ge-4x3',
  'flag:gf-4x3',
  'flag:gg-4x3',
  'flag:gh-4x3',
  'flag:gi-4x3',
  'flag:gl-4x3',
  'flag:gm-4x3',
  'flag:gn-4x3',
  'flag:gp-4x3',
  'flag:gq-4x3',
  'flag:gr-4x3',
  'flag:gs-4x3',
  'flag:gt-4x3',
  'flag:gu-4x3',
  'flag:gw-4x3',
  'flag:gy-4x3',
  'flag:hk-4x3',
  'flag:hm-4x3',
  'flag:hn-4x3',
  'flag:hr-4x3',
  'flag:ht-4x3',
  'flag:hu-4x3',
  'flag:id-4x3',
  'flag:ie-4x3',
  'flag:il-4x3',
  'flag:im-4x3',
  'flag:in-4x3',
  'flag:io-4x3',
  'flag:iq-4x3',
  'flag:ir-4x3',
  'flag:is-4x3',
  'flag:it-4x3',
  'flag:je-4x3',
  'flag:jm-4x3',
  'flag:jo-4x3',
  'flag:jp-4x3',
  'flag:ke-4x3',
  'flag:kg-4x3',
  'flag:kh-4x3',
  'flag:ki-4x3',
  'flag:km-4x3',
  'flag:kn-4x3',
  'flag:kp-4x3',
  'flag:kr-4x3',
  'flag:kw-4x3',
  'flag:ky-4x3',
  'flag:kz-4x3',
  'flag:la-4x3',
  'flag:lb-4x3',
  'flag:lc-4x3',
  'flag:li-4x3',
  'flag:lk-4x3',
  'flag:lr-4x3',
  'flag:ls-4x3',
  'flag:lt-4x3',
  'flag:lu-4x3',
  'flag:lv-4x3',
  'flag:ly-4x3',
  'flag:ma-4x3',
  'flag:mc-4x3',
  'flag:md-4x3',
  'flag:me-4x3',
  'flag:mf-4x3',
  'flag:mg-4x3',
  'flag:mh-4x3',
  'flag:mk-4x3',
  'flag:ml-4x3',
  'flag:mm-4x3',
  'flag:mn-4x3',
  'flag:mo-4x3',
  'flag:mp-4x3',
  'flag:mq-4x3',
  'flag:mr-4x3',
  'flag:ms-4x3',
  'flag:mt-4x3',
  'flag:mu-4x3',
  'flag:mv-4x3',
  'flag:mw-4x3',
  'flag:mx-4x3',
  'flag:my-4x3',
  'flag:mz-4x3',
  'flag:na-4x3',
  'flag:nc-4x3',
  'flag:ne-4x3',
  'flag:nf-4x3',
  'flag:ng-4x3',
  'flag:ni-4x3',
  'flag:nl-4x3',
  'flag:no-4x3',
  'flag:np-4x3',
  'flag:nr-4x3',
  'flag:nu-4x3',
  'flag:nz-4x3',
  'flag:om-4x3',
  'flag:pa-4x3',
  'flag:pe-4x3',
  'flag:pf-4x3',
  'flag:pg-4x3',
  'flag:ph-4x3',
  'flag:pk-4x3',
  'flag:pl-4x3',
  'flag:pm-4x3',
  'flag:pn-4x3',
  'flag:pr-4x3',
  'flag:ps-4x3',
  'flag:pt-4x3',
  'flag:pw-4x3',
  'flag:py-4x3',
  'flag:qa-4x3',
  'flag:re-4x3',
  'flag:ro-4x3',
  'flag:rs-4x3',
  'flag:ru-4x3',
  'flag:rw-4x3',
  'flag:sa-4x3',
  'flag:sb-4x3',
  'flag:sc-4x3',
  'flag:sd-4x3',
  'flag:se-4x3',
  'flag:sg-4x3',
  'flag:sh-4x3',
  'flag:si-4x3',
  'flag:sj-4x3',
  'flag:sk-4x3',
  'flag:sl-4x3',
  'flag:sm-4x3',
  'flag:sn-4x3',
  'flag:so-4x3',
  'flag:sr-4x3',
  'flag:ss-4x3',
  'flag:st-4x3',
  'flag:sv-4x3',
  'flag:sx-4x3',
  'flag:sy-4x3',
  'flag:sz-4x3',
  'flag:tc-4x3',
  'flag:td-4x3',
  'flag:tf-4x3',
  'flag:tg-4x3',
  'flag:th-4x3',
  'flag:tj-4x3',
  'flag:tk-4x3',
  'flag:tl-4x3',
  'flag:tm-4x3',
  'flag:tn-4x3',
  'flag:to-4x3',
  'flag:tr-4x3',
  'flag:tt-4x3',
  'flag:tv-4x3',
  'flag:tw-4x3',
  'flag:tz-4x3',
  'flag:ua-4x3',
  'flag:ug-4x3',
  'flag:us-4x3',
  'flag:uy-4x3',
  'flag:uz-4x3',
  'flag:va-4x3',
  'flag:vc-4x3',
  'flag:ve-4x3',
  'flag:vg-4x3',
  'flag:vi-4x3',
  'flag:vn-4x3',
  'flag:vu-4x3',
  'flag:wf-4x3',
  'flag:ws-4x3',
  'flag:xk-4x3',
  'flag:ye-4x3',
  'flag:yt-4x3',
  'flag:za-4x3',
  'flag:zm-4x3',
  'flag:zw-4x3',
];
